module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_dilts_sm-64e9945223e71c7ae66fab7a47b2e9f4.png";